export default import.meta.ROLLDOWN_FILE_URL_WKhNpUFRncUEuMcY8stSTw